import BaseButton from "../base-button";
import {buttonEnum, positionEnum, dimensionEnum} from "../helper";

class PlayButton extends BaseButton {
    mesh;
    audio;
    allowedDelay = 2000;
    time;
    zAxisPosition = -0.5;

    constructor() {
        const {scale, position} = mapScreenDimensionTo3D(isVRModeEnabled() ? positionEnum.PLAY_VR : positionEnum.PLAY_NON_VR, isVRModeEnabled() ? dimensionEnum.PLAY_VR : dimensionEnum.PLAY_NON_VR)
        super({
            parent: isVRModeEnabled() ? cameraTracker : iq3Camera.camera,
            position: position,
            isIconButton: true,
            isVisible: false,
            iconSource: 'icons/mute.png',
            scale: scale,
            name: buttonEnum.PLAY
        });
    }

    initiateAudio(audio) {
        this.audio = audio;
        this.setVisibility(true);
        this.setCallback(this.buttonClickCallback);
        this.time = Date.now();
    }

    buttonClickCallback() {
        this.setVisibility(false);
        this.setAudioTime();
        this.audio.play();
    }

    setAudioTime() {
        const elapsedTime = Date.now() - this.time;
        if (elapsedTime > this.allowedDelay) {
            this.audio.currentTime = elapsedTime / 1000;
        }
    }

    onVRModeChange() {
        if (isVRModeEnabled()) {
            this.setParent(cameraTracker);
            this.setLocationAndDimension(positionEnum.PLAY_VR, dimensionEnum.PLAY_VR);
            this.updateZAxisPosition(this.zAxisPosition);
            return;
        }

        this.setParent(iq3Camera.camera);
        this.setLocationAndDimension(positionEnum.PLAY_NON_VR, dimensionEnum.PLAY_NON_VR);
    }
}

export default PlayButton;
